import Cookies from 'universal-cookie';
import { round } from './round';
const cookies = new Cookies();

/**
 * Returns the minimum decimal places needed to display a value accurately.
 * Shows at least minDecimals (default 2), but preserves up to maxDecimals
 * if the value has significant digits beyond minDecimals.
 *
 * Examples (minDecimals=2, maxDecimals=4):
 *   10       → 2  (displays as "10,00")
 *   10.12    → 2  (displays as "10,12")
 *   10.123   → 3  (displays as "10,123")
 *   10.1234  → 4  (displays as "10,1234")
 */
export function getDisplayDecimalPlaces(
  value,
  minDecimals = 2,
  maxDecimals
) {
  if (maxDecimals == null || maxDecimals <= minDecimals) return minDecimals;
  const num = parseFloat(value);
  if (num == null || isNaN(num)) return minDecimals;
  const rounded = round(num, maxDecimals);
  for (let d = minDecimals; d < maxDecimals; d++) {
    if (round(rounded, d) === rounded) return d;
  }
  return maxDecimals;
}
export const numberToString = (
  number = 0,
  decimalPlaces = 2,

  thousandSeparator = '.',
  separator = cookies.get('decimalSeparator')
) => {
  if (number === null) return '';
  if (!separator) separator = ',';
  if (
    number === '' ||
    Number.isNaN(parseFloat(number)) ||
    number == null ||
    number == undefined
  )
    return `0${separator}`;
  const parsed = parseFloat(number);

  if (decimalPlaces === null) {
    let parts = String(parsed).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    return parts.length > 1 ? parts.join(separator) : parts[0];
  }

  var roundedNumber = parseFloat(
    round(parsed, decimalPlaces)
  ).toFixed(decimalPlaces);

  let parts = roundedNumber.split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);

  return decimalPlaces ? parts.join(separator) : parts[0];
};

export const stringToNumber = (
  string = '0',
  decimalPlaces = 2,
  thousandSeparator = '.',
  separator = cookies.get('decimalSeparator')
) => {
  if (!string) return 0;
  if (!separator) separator = ',';
  const normalizedString = string
    .split(thousandSeparator)
    .join('') // removes all thousand separators
    .replace(separator, '.');

  const number = decimalPlaces
    ? normalizedString
    : round(parseFloat(normalizedString), decimalPlaces);
  return isNaN(number) ? 0 : number;
};
